import { render, staticRenderFns } from "./CommittedEdit.vue?vue&type=template&id=9c84b868&"
import script from "./CommittedEdit.vue?vue&type=script&lang=js&"
export * from "./CommittedEdit.vue?vue&type=script&lang=js&"
import style0 from "./CommittedEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports